export var validateExternalTicketForm = function (formData) {
    var errors = {};
    // Client information validation
    if (formData.client_selection === 'existing' && !formData.apartment_contact_id) {
        errors.apartment_contact_id = 'Debe seleccionar un contacto existente';
    }
    if (formData.client_selection === 'new') {
        if (!formData.external_client_first_name.trim()) {
            errors.external_client_first_name = 'Nombre es requerido';
        }
        if (!formData.external_client_last_name.trim()) {
            errors.external_client_last_name = 'Apellido es requerido';
        }
        if (!formData.external_client_phone.trim()) {
            errors.external_client_phone = 'Teléfono es requerido';
        }
        if (!formData.external_client_email.trim()) {
            errors.external_client_email = 'Email es requerido';
        }
        else if (!/\S+@\S+\.\S+/.test(formData.external_client_email)) {
            errors.external_client_email = 'Email inválido';
        }
    }
    if (formData.client_selection === 'other') {
        if (!formData.external_client_first_name.trim()) {
            errors.external_client_first_name = 'Nombre es requerido';
        }
        if (!formData.external_client_last_name.trim()) {
            errors.external_client_last_name = 'Apellido es requerido';
        }
        if (!formData.external_client_phone.trim()) {
            errors.external_client_phone = 'Teléfono es requerido';
        }
    }
    return errors;
};
export var validateInternalTicketForm = function () {
    // Internal tickets don't have additional validation beyond base validation
    return {};
};
